<button kendoButton class="bookmark-icon" *ngIf="isFavouriteAdded$ | async as isBookMarked; else notBookmarked"
(click)="addOrRemoveFavourite(false)">
    <img src="assets/w-ui-angular/images/bookmark_done.svg" alt="bookmark">
</button>

<ng-template #notBookmarked>
    <button kendoButton class="bookmark-icon" (click)="addOrRemoveFavourite(true)">
        <img src="assets/w-ui-angular/images/bookmark_none.svg" alt="bookmark">
    </button>
</ng-template>